import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { FileUploadResponse } from 'src/app/core/models/file-upload-results.model';
import { WarehouseOutboundRequest } from 'src/app/core/models/inbound/warehouse-scan';
import { environment } from 'src/app/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class WarehouseOutboundService {
  private readonly _http = inject(HttpClient);
  private readonly _errorHandler = inject(ErrorhandleService);

  readonly baseUrl = environment.apiUrl.concat('/warehouse');

  /**
   *outbound scan
   * @return {*}  {Observable<WarehouseOutboundResponse>}
   * @memberof WarehouseOutboundService
   */
  outboundScan(
    warehouseOutboundRequest: WarehouseOutboundRequest,
  ): Observable<FileUploadResponse> {
    return this._http
      .post<FileUploadResponse>(
        this.baseUrl.concat('/outbound/scan/'),
        warehouseOutboundRequest,
      )
      .pipe(
        take(1),
        catchError((error) =>
          this._errorHandler.handleError<FileUploadResponse>(
            error,
            error.error.code,
            'WarehouseOutbound Service: outbound scan',
            BANNER_TYPE.API_400_ERROR,
            {} as FileUploadResponse,
          ),
        ),
      );
  }
}
